import { useSearchParams } from "react-router-dom";

export default function Login() {
  const [queryParams, setQueryParams] = useSearchParams();

  const handleLogin = () => {
    let url = "/auth/login";
    if (queryParams.get("redirect_uri")) {
      url += "?redirect_uri=" + queryParams.get("redirect_uri");
    }
    window.location.href = url;
  };

  return (
    <>
      <button id="btn-login" className="btn btn-primary " onClick={handleLogin}>
        Login
      </button>
    </>
  );
}
